<template>
  <div class="contact-box">
    <div class="info">
      <div class="left">
        <div>
          <span>上海总公司：</span>
          <p>{{contact.addrShanghai}}</p>
        </div>
        <div>
          <span>嘉兴研发中心：</span>
          <p>{{contact.addrJiaxing}}</p>
        </div>
        <div>
          <span>咨询电话：</span>
          <p>{{contact.tel}}</p>
        </div>
        <div>
          <span>用户交流群：</span>
          <p>{{contact.chatGroup}}</p>
        </div>
        <div>
          <span>市场邮箱：</span>
          <p> {{contact.mailMarketing}}</p>
        </div>
        <div>
          <span>商务邮箱：</span>
          <p>{{contact.mailBusiness}}</p>
        </div>
<!--        <span>官方微博：</span></span><a :href="contact.weibo"-->
<!--           target="_blank"><span class="circle"><img :src="contact.weiboImg" /></span></a>-->
      </div>
      <div class="right hidden-md-and-down">
        <div class="img-area">
          <img :src="contact.weixinImg"
               width="100%" />
        </div>
        <p>微信公众号</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  components: {},
  data() {
    return {
      contact: {
        addrShanghai: "上海市徐汇区龙耀路18号X3栋3楼",
        addrJiaxing: "嘉兴市南湖区亚太路705号清华研究院10楼",
        tel: "13033677897",
        online: "QQ:2629198267",
        chatGroup: "QQ:1039327587",
        mailMarketing: "marketing@anchora.me",
        mailBusiness: "sales@anchora.me",
        weiboImg: require("@/assets/images/sina32.png"),
        weibo: "http://weibo.com/mopaas",
        weixinImg: require("@/assets/images/erweim.jpg")
      }
    };
  }
};
</script>

<style>
@media (min-width: 992px) {
  .contact-box {
    width: 100%;
  }

  .contact-box .info {
    width: 800px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    line-height: 2.5;
  }

  .contact-box .info .left span {
    display: inline-block;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(87, 90, 102, 1);
    text-align: left;
    width: 140px;
    float: left;
  }

  .contact-box .info .left p {
    display: inline-block;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(87, 90, 102, 1);
    width: 400px;
    text-align: left;
  }

  .contact-box .info .right p {
    font-family: "microsoft yahei";
    font-size: 14px;
    font-weight: bold;
    color: rgba(78, 79, 80, 1);
    text-align: center;
  }

  .contact-box .info .right .img-area {
    width: 150px;
  }
}

@media (max-width: 992px) {
  .contact-box {
    width: 100%;
  }

  .contact-box .info {
    line-height: 1.5;
  }

  .contact-box .info .left > div {
    margin-bottom: 5px;
  }

  .contact-box .info .left span {
    display: inline-block;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(87, 90, 102, 1);
    text-align: left;
    float: left;
    font-weight: bold;
  }

  .contact-box .info .left p {
    /* display: inline-block; */
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(87, 90, 102, 1);
    text-align: left;
  }

  .contact-box .info .left img {
    width: 20px;
  }

  .contact-box .info .right p {
    font-family: "microsoft yahei";
    font-size: 14px;
    font-weight: bold;
    color: rgba(78, 79, 80, 1);
    text-align: center;
  }

  .contact-box .info .right .img-area {
    width: 150px;
  }
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/ContactUs.vue